import capitalize from 'lodash/capitalize';
import { BookkeepingAccount } from '~/types/general-bookkeeping';

export const checkBookkeepingAccountMatch = (account: BookkeepingAccount, searchText: string): boolean => {
  const extraCharacters = /[./]/g;

  return (
    account.code.toLowerCase().includes(searchText.toLowerCase()) ||
    account.code
      .toLowerCase()
      .replaceAll(extraCharacters, '')
      .startsWith(searchText.toLowerCase().replaceAll(extraCharacters, '')) ||
    account.name.toLowerCase().includes(searchText.toLowerCase()) ||
    bookkeepingAccountLabel(account).toLowerCase().includes(searchText.toLowerCase())
  );
};

export const bookkeepingAccountLabel = (account: BookkeepingAccount): string => {
  return `${account.code} - ${capitalize(account.name)}`;
};

export const bookkeepingAccountDescription = (account: BookkeepingAccount): string => {
  return capitalize(account.section);
};
